import { compose } from "recompose";
import { hocFactory } from "../../factory";
export const hoc = compose(hocFactory.get("utils")(), hocFactory.get("make")());
//# sourceMappingURL=container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/components/formitem/container.js
// module id = 341
// module chunks = 3